// in DD/MM/YYYY format: 14/05/2026
const dateInDDMMYYYY = '14/05/2026';

export const bannerUpdateTimestamp = new Date(dateInDDMMYYYY.split('/').reverse().join('-')).getTime();
